(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const drawer=document.querySelector('[data-cart-drawer]');
  if(!drawer)return;
  const mobile=matchMedia('(max-width:749px)');
  const initialize=()=>drawer.querySelectorAll('[data-cart-compact-policies]:not([data-compact-ready])').forEach(details=>{
    details.open=!mobile.matches;
    details.setAttribute('data-compact-ready','');
  });
  initialize();
  new MutationObserver(initialize).observe(drawer,{childList:true,subtree:true});
  mobile.addEventListener('change',()=>drawer.querySelectorAll('[data-cart-compact-policies]').forEach(details=>{details.open=!mobile.matches;}));
})();
  } catch(e) { console.error(e); }
})();

})();
